import { Component, inject } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

import { IConfirmDialogData } from './confirm-dialog-data';

@Component({
  selector: 'kh-confirm-dialog',
  styleUrls: ['./confirm-dialog.component.less'],
  templateUrl: './confirm-dialog.component.html',
  standalone: false
})
export class ConfirmDialogComponent implements IConfirmDialogData {
  public readonly bsModalRef = inject(BsModalRef);

  public title = '';
  public body = '';
  public firstButtonText = '';
  public secondButtonText = '';
  public roundedButtons = false;

  public firstButtonHandler(): void {
    // do nothing. That is a placeholder.
  }

  public secondButtonHandler(): void {
    // do nothing. That is a placeholder.
  }

  public close(): void {
    this.bsModalRef.hide();
  }

  public onFirstButtonClick(): void {
    this.close();
    this.firstButtonHandler();
  }

  public onSecondButtonClick(): void {
    this.close();
    this.secondButtonHandler();
  }
}
